import { escapeHTML, traducirErrorAuth } from "../core/utils.js";
import { dispositivoEsConfiable, renderPantallaMFAChallenge } from "./mfa.js";
import { arrancarDespuesDeLogin } from "./session.js";
import { AURA_ISOTIPO, AURA_LOGO, BRAND, C } from "../core/config.js";
import { supa } from "../core/supabaseClient.js";
import { abrirSplash } from "../ui/splash.js";
import { obtenerTenantIdDelUsuario } from "../core/cloudSync.js";

// Pantalla de ingreso del ERP. Es la "puerta del producto": SIEMPRE muestra la
// marca del ERP (AURA_LOGO/AURA_ISOTIPO), nunca el logo del inquilino. Diseño de
// dos paneles: a la izquierda un hero de marca (navy Aura con resplandor cian e
// isotipo de fondo) y a la derecha el formulario. En móvil se apila en una sola
// columna. IDs que consume intentarLogin(): __login_email, __login_password,
// __login_btn, __login_status.
export function renderPantallaLogin(mensajeError) {
  const root = document.getElementById("root");
  const features = [
    { icon: "🧾", titulo: "Facturación electrónica DIAN", texto: "Emite y controla tus documentos desde un solo lugar." },
    { icon: "📊", titulo: "Contabilidad e inventario en vivo", texto: "Cartera, costos y estados financieros en tiempo real." },
    { icon: "🔐", titulo: "Acceso seguro", texto: "Verificación en dos pasos para todas las cuentas." },
  ];
  root.innerHTML = `
    <div id="aura-login">
      <style>
        #aura-login{position:fixed;inset:0;display:flex;min-height:100vh;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;overflow:auto;
          transition:filter 1.1s cubic-bezier(.33,0,.2,1),opacity 1.1s cubic-bezier(.33,0,.2,1),transform 1.1s cubic-bezier(.33,0,.2,1);}
        /* Al pulsar "Iniciar sesión" el formulario empieza a difuminarse y a
           retroceder de inmediato: da respuesta visual durante la espera de red
           en vez de quedarse congelado, y deja el terreno preparado para que la
           bienvenida se funda encima sin ningún corte. */
        #aura-login.al-saliendo{filter:blur(8px);opacity:.45;transform:scale(1.02);pointer-events:none;}
        #aura-login *{box-sizing:border-box;}
        #aura-login .al-hero{position:relative;flex:1.05;overflow:hidden;color:#fff;background:linear-gradient(160deg,#0B132B 0%,#12264D 55%,#0B132B 100%);padding:56px 52px;display:flex;flex-direction:column;justify-content:space-between;}
        #aura-login .al-glow{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
        #aura-login .al-glow.g1{width:340px;height:340px;top:-90px;right:-70px;background:rgba(0,229,255,.22);}
        #aura-login .al-glow.g2{width:300px;height:300px;bottom:-110px;left:-80px;background:rgba(18,38,77,.55);}
        #aura-login .al-watermark{position:absolute;right:-40px;bottom:-30px;width:360px;opacity:.06;transform:rotate(-8deg);pointer-events:none;}
        #aura-login .al-hero-top,#aura-login .al-hero-foot{position:relative;z-index:1;}
        #aura-login .al-logo{height:118px;max-width:100%;object-fit:contain;display:block;filter:drop-shadow(0 10px 26px rgba(0,0,0,.35));image-rendering:-webkit-optimize-contrast;}
        #aura-login .al-headline{font-size:30px;font-weight:800;line-height:1.2;margin:34px 0 12px;letter-spacing:-.4px;max-width:440px;}
        #aura-login .al-headline .cy{color:#22ECFF;}
        #aura-login .al-slogan{font-size:14.5px;color:#c7d2e5;margin:0 0 30px;max-width:420px;line-height:1.55;}
        #aura-login .al-feat{display:flex;gap:14px;align-items:flex-start;margin-bottom:16px;max-width:430px;}
        #aura-login .al-feat-ico{flex:none;width:40px;height:40px;border-radius:11px;display:flex;align-items:center;justify-content:center;font-size:19px;background:rgba(0,229,255,.10);border:1px solid rgba(0,229,255,.22);}
        #aura-login .al-feat-t{font-size:13.5px;font-weight:700;color:#fff;margin:2px 0 2px;}
        #aura-login .al-feat-x{font-size:12.5px;color:#9fb0cc;line-height:1.45;}
        #aura-login .al-hero-foot{font-size:11.5px;color:#7488ab;letter-spacing:.3px;}
        #aura-login .al-form-wrap{flex:1;display:flex;align-items:center;justify-content:center;background:#f4f6fb;padding:40px 28px;}
        #aura-login .al-card{width:100%;max-width:404px;animation:alIn .5s cubic-bezier(.16,.8,.3,1);}
        @keyframes alIn{from{opacity:0;transform:translateY(14px);}to{opacity:1;transform:none;}}
        #aura-login .al-mark{display:none;margin:0 auto 20px;width:76px;height:76px;border-radius:18px;box-shadow:0 10px 24px rgba(11,19,43,.28);}
        #aura-login .al-title{font-size:23px;font-weight:800;color:#0f172a;margin:0 0 6px;letter-spacing:-.3px;}
        #aura-login .al-sub{font-size:13.5px;color:#64748b;margin:0 0 24px;}
        #aura-login .al-err{background:#fef2f2;border:1px solid #fca5a5;color:#dc2626;font-size:12.5px;padding:11px 13px;border-radius:10px;margin-bottom:18px;display:flex;gap:8px;align-items:flex-start;line-height:1.4;}
        #aura-login .al-label{font-size:12px;font-weight:600;color:#334155;display:block;margin:0 0 6px;}
        #aura-login .al-field{position:relative;margin-bottom:16px;}
        #aura-login .al-field-ico{position:absolute;left:13px;top:50%;transform:translateY(-50%);font-size:15px;opacity:.6;pointer-events:none;}
        #aura-login .al-input{width:100%;height:48px;padding:0 44px;border:1.5px solid #e2e8f0;border-radius:11px;font-size:14.5px;color:#0f172a;background:#fff;font-family:inherit;outline:none;transition:border-color .15s,box-shadow .15s;}
        #aura-login .al-input::placeholder{color:#94a3b8;}
        #aura-login .al-input:focus{border-color:#00C2E0;box-shadow:0 0 0 4px rgba(0,194,224,.16);}
        #aura-login .al-eye{position:absolute;right:8px;top:50%;transform:translateY(-50%);border:none;background:transparent;cursor:pointer;font-size:16px;padding:8px;border-radius:8px;line-height:1;opacity:.65;}
        #aura-login .al-eye:hover{opacity:1;background:#f1f5f9;}
        #aura-login .al-btn{width:100%;height:50px;margin-top:6px;background:linear-gradient(135deg,#12264D,#0B132B);color:#fff;border:none;border-radius:11px;font-weight:700;font-size:15px;cursor:pointer;letter-spacing:.3px;font-family:inherit;transition:filter .15s,transform .05s,box-shadow .15s;box-shadow:0 10px 22px rgba(18,38,77,.22);}
        #aura-login .al-btn:hover{filter:brightness(1.08);box-shadow:0 12px 26px rgba(18,38,77,.30);}
        #aura-login .al-btn:active{transform:translateY(1px);}
        #aura-login .al-btn:disabled{opacity:.7;cursor:default;filter:none;}
        #aura-login .al-status{text-align:center;margin-top:14px;font-size:12.5px;color:#64748b;min-height:16px;}
        #aura-login .al-foot{text-align:center;margin-top:26px;font-size:11px;color:#94a3b8;letter-spacing:.3px;}
        @media (max-width:900px){
          #aura-login{flex-direction:column;position:absolute;}
          #aura-login .al-hero{flex:none;padding:30px 24px 26px;text-align:center;align-items:center;}
          #aura-login .al-logo{height:74px;margin:0 auto;}
          #aura-login .al-headline{font-size:21px;margin:18px auto 8px;}
          #aura-login .al-slogan{margin:0 auto;font-size:13px;}
          #aura-login .al-feat,#aura-login .al-hero-foot,#aura-login .al-watermark{display:none;}
          #aura-login .al-form-wrap{padding:30px 20px 44px;}
        }
        @media (max-width:420px){
          #aura-login .al-hero{display:none;}
          #aura-login .al-mark{display:block;}
        }
      </style>

      <div class="al-hero">
        <div class="al-glow g1"></div>
        <div class="al-glow g2"></div>
        <img class="al-watermark" src="${AURA_ISOTIPO}" alt=""/>
        <div class="al-hero-top">
          <img class="al-logo" src="${AURA_LOGO}" alt="${BRAND.producto}"/>
          <h1 class="al-headline">Todo tu negocio, <span class="cy">bajo control</span>.</h1>
          <p class="al-slogan">${BRAND.slogan}</p>
          <div class="al-feats">
            ${features.map(f => `
              <div class="al-feat">
                <div class="al-feat-ico">${f.icon}</div>
                <div>
                  <div class="al-feat-t">${f.titulo}</div>
                  <div class="al-feat-x">${f.texto}</div>
                </div>
              </div>`).join("")}
          </div>
        </div>
        <div class="al-hero-foot">© ${BRAND.producto}</div>
      </div>

      <div class="al-form-wrap">
        <div class="al-card">
          <img class="al-mark" src="${AURA_ISOTIPO}" alt="${BRAND.producto}"/>
          <h2 class="al-title">Iniciar sesión</h2>
          <p class="al-sub">Ingresa tus credenciales para continuar.</p>
          ${mensajeError ? `<div class="al-err"><span>⚠️</span><span>${mensajeError}</span></div>` : ""}
          <label class="al-label" for="__login_email">Correo</label>
          <div class="al-field">
            <span class="al-field-ico">✉️</span>
            <input id="__login_email" class="al-input" type="email" autocomplete="username" placeholder="tucorreo@empresa.com"/>
          </div>
          <label class="al-label" for="__login_password">Contraseña</label>
          <div class="al-field">
            <span class="al-field-ico">🔒</span>
            <input id="__login_password" class="al-input" type="password" autocomplete="current-password" placeholder="••••••••"/>
            <button id="__login_eye" type="button" class="al-eye" title="Mostrar u ocultar la contraseña" aria-label="Mostrar u ocultar la contraseña">👁️</button>
          </div>
          <button id="__login_btn" class="al-btn">Iniciar sesión</button>
          <div id="__login_status" class="al-status"></div>
          <div class="al-foot">${BRAND.producto} · v5.1</div>
        </div>
      </div>
    </div>
  `;
  document.getElementById("__login_btn").addEventListener("click", intentarLogin);
  document.getElementById("__login_email").addEventListener("keydown", e => { if (e.key === "Enter") intentarLogin(); });
  document.getElementById("__login_password").addEventListener("keydown", e => { if (e.key === "Enter") intentarLogin(); });
  const eye = document.getElementById("__login_eye");
  eye.addEventListener("click", () => {
    const inp = document.getElementById("__login_password");
    const visible = inp.type === "text";
    inp.type = visible ? "password" : "text";
    eye.textContent = visible ? "👁️" : "🙈";
    inp.focus();
  });
  const email = document.getElementById("__login_email");
  if (email) email.focus();
}

export async function intentarLogin() {
  const email = document.getElementById("__login_email").value.trim();
  const password = document.getElementById("__login_password").value;
  const statusEl = document.getElementById("__login_status");
  const btn = document.getElementById("__login_btn");
  if (!email || !password) { statusEl.textContent = "Ingresa correo y contraseña."; return; }
  btn.disabled = true; btn.textContent = "Entrando..."; statusEl.textContent = "";
  document.getElementById("aura-login")?.classList.add("al-saliendo");

  // La bienvenida se construye YA, oculta, para que la creación de los dos
  // contextos WebGL y la compilación de los shaders —trabajo síncrono de decenas
  // a cientos de milisegundos— ocurran durante la espera de red y no justo
  // cuando debería correr el fundido. Ese bloqueo del hilo principal era lo que
  // hacía que la aparición se viera de golpe por muy larga que fuese la
  // transición. Al revelarla después solo queda componer una capa ya lista.
  const bienvenida = abrirSplash({ oculto: true });

  const { data, error } = await supa.auth.signInWithPassword({ email, password });
  if (error) {
    bienvenida.cerrar();   // nunca se llegó a ver
    renderPantallaLogin("No se pudo iniciar sesión: " + traducirErrorAuth(error.message));
    return;
  }
  // El ingreso se anota en la bitácora cuando la app termina de abrir (antes
  // no hay empresa a la cual escribirlo); recargar la página no es ingresar.
  try { sessionStorage.setItem("aura:ingreso_pendiente", "1"); } catch { /* sin marca, sin evento */ }
  await continuarLoginConMFA(data.user.id, bienvenida);
}

// Pantalla de cambio de contraseña OBLIGATORIO: se muestra cuando un admin
// marcó al usuario con must_change_password. No se puede saltar (solo cerrar
// sesión). El cambio se hace con la sesión del propio usuario
// (supa.auth.updateUser), así se aplica la política de contraseñas de Supabase
// (longitud mínima, complejidad, contraseñas filtradas); luego la edge function
// admin-usuarios limpia la marca.
export function renderPantallaCambioPassword(userId, motivo) {
  const root = document.getElementById("root");
  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle at 30% 20%,#0B132B 0%,${C.mathiz} 45%,#0B132B 100%);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;padding:20px;">
      <div style="background:white;border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.35);max-width:440px;width:100%;overflow:hidden;">
        <div style="height:5px;background:linear-gradient(90deg,${C.gold},${C.mathiz});"></div>
        <div style="padding:40px 36px 36px;">
          <div style="text-align:center;margin-bottom:22px;">
            <div style="font-size:40px;margin-bottom:10px;">🔑</div>
            <h2 style="margin:0 0 6px;font-size:18px;color:${C.text};">Debes cambiar tu contraseña</h2>
            <p style="color:#6b7280;font-size:13px;margin:0;">${motivo ? escapeHTML(motivo) : "Un administrador solicitó que definas una contraseña nueva antes de continuar."}</p>
          </div>
          <div style="margin-bottom:12px;">
            <label style="font-size:12px;font-weight:600;color:#374151;display:block;margin-bottom:5px;">Nueva contraseña</label>
            <input id="__cp_pass1" type="password" placeholder="••••••••" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;"/>
          </div>
          <div style="margin-bottom:14px;">
            <label style="font-size:12px;font-weight:600;color:#374151;display:block;margin-bottom:5px;">Repite la nueva contraseña</label>
            <input id="__cp_pass2" type="password" placeholder="••••••••" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;"/>
          </div>
          <div style="font-size:11px;color:#94a3b8;margin-bottom:16px;">Mínimo 8 caracteres, con mayúsculas, minúsculas, números y símbolos. No puede ser una contraseña filtrada conocida.</div>
          <div id="__cp_mfa_wrap" style="display:none;margin-bottom:16px;padding:12px 14px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;">
            <label style="font-size:12px;font-weight:600;color:#374151;display:block;margin-bottom:5px;">🔐 Código de verificación (dos pasos)</label>
            <input id="__cp_mfa" type="text" inputmode="numeric" maxlength="6" placeholder="000000" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:16px;text-align:center;letter-spacing:4px;"/>
            <div style="font-size:11px;color:#94a3b8;margin-top:5px;">Por seguridad, para cambiar la contraseña confirma con el código de 6 dígitos de tu app autenticadora.</div>
          </div>
          <button id="__cp_btn" style="width:100%;background:linear-gradient(135deg,${C.mathiz},#0B132B);color:white;border:none;padding:12px;border-radius:8px;font-weight:700;font-size:14px;cursor:pointer;letter-spacing:.3px;">Guardar y continuar</button>
          <div id="__cp_status" style="text-align:center;margin-top:14px;font-size:12px;color:#dc2626;"></div>
          <div style="text-align:center;margin-top:14px;">
            <button id="__cp_salir" style="background:transparent;border:none;color:#94a3b8;font-size:12px;cursor:pointer;text-decoration:underline;">Cerrar sesión</button>
          </div>
        </div>
      </div>
    </div>
  `;
  document.getElementById("__cp_salir").addEventListener("click", async () => { await supa.auth.signOut(); location.reload(); });
  const submit = () => cambiarPasswordForzado(userId);
  document.getElementById("__cp_btn").addEventListener("click", submit);
  document.getElementById("__cp_pass2").addEventListener("keydown", e => { if (e.key === "Enter") submit(); });

  // Si la sesión aún no es AAL2 (p. ej. se entró desde un dispositivo de
  // confianza que se saltó el reto MFA) y el usuario tiene verificación en dos
  // pasos, Supabase exige AAL2 para cambiar la contraseña. Mostramos el campo
  // del código para poder elevar la sesión antes de guardar.
  (async () => {
    try {
      const { data: aal } = await supa.auth.mfa.getAuthenticatorAssuranceLevel();
      if (aal && aal.nextLevel === "aal2" && aal.currentLevel !== "aal2") {
        const wrap = document.getElementById("__cp_mfa_wrap");
        if (wrap) wrap.style.display = "block";
        const mfa = document.getElementById("__cp_mfa");
        if (mfa) mfa.addEventListener("keydown", e => { if (e.key === "Enter") submit(); });
      }
    } catch { /* si no se puede consultar el AAL, el envío intentará igual */ }
  })();
}

async function cambiarPasswordForzado(userId) {
  const p1 = document.getElementById("__cp_pass1").value;
  const p2 = document.getElementById("__cp_pass2").value;
  const statusEl = document.getElementById("__cp_status");
  const btn = document.getElementById("__cp_btn");
  if (p1.length < 8) { statusEl.textContent = "La contraseña debe tener al menos 8 caracteres."; return; }
  if (p1 !== p2) { statusEl.textContent = "Las dos contraseñas no coinciden."; return; }
  btn.disabled = true; btn.textContent = "Guardando…"; statusEl.textContent = "";

  // 0. Elevar a AAL2 si hace falta. Cuando el usuario tiene verificación en dos
  // pasos, Supabase EXIGE una sesión AAL2 para cambiar la contraseña. Si se
  // entró desde un dispositivo de confianza, el reto MFA se saltó y la sesión
  // quedó en AAL1: aquí se completa con el código antes de guardar. En
  // dispositivos nuevos el usuario ya pasó el reto en el login (ya es AAL2) y
  // este paso se omite.
  try {
    const { data: aal } = await supa.auth.mfa.getAuthenticatorAssuranceLevel();
    if (aal && aal.nextLevel === "aal2" && aal.currentLevel !== "aal2") {
      const wrap = document.getElementById("__cp_mfa_wrap");
      if (wrap) wrap.style.display = "block";
      const codigo = (document.getElementById("__cp_mfa")?.value || "").trim();
      if (!codigo) {
        statusEl.textContent = "Ingresa el código de 6 dígitos de tu app autenticadora para confirmar el cambio.";
        btn.disabled = false; btn.textContent = "Guardar y continuar";
        return;
      }
      const { data: factores, error: errF } = await supa.auth.mfa.listFactors();
      const factor = !errF && (factores.totp || []).find(f => f.status === "verified");
      if (!factor) {
        statusEl.textContent = traducirErrorAuth("factor not found");
        btn.disabled = false; btn.textContent = "Guardar y continuar";
        return;
      }
      const { data: challenge, error: errC } = await supa.auth.mfa.challenge({ factorId: factor.id });
      if (errC) {
        statusEl.textContent = "No se pudo verificar: " + traducirErrorAuth(errC.message);
        btn.disabled = false; btn.textContent = "Guardar y continuar";
        return;
      }
      const { error: errV } = await supa.auth.mfa.verify({ factorId: factor.id, challengeId: challenge.id, code: codigo });
      if (errV) {
        statusEl.textContent = traducirErrorAuth("Invalid TOTP code");
        btn.disabled = false; btn.textContent = "Guardar y continuar";
        return;
      }
    }
  } catch { /* si la consulta de AAL falla, se intenta el cambio igual y el error de abajo lo informa */ }

  // 1. Cambiar la contraseña con la sesión del propio usuario (aplica la política de Supabase).
  const { error: errPass } = await supa.auth.updateUser({ password: p1 });
  if (errPass) {
    statusEl.textContent = "No se pudo cambiar: " + traducirErrorAuth(errPass.message);
    btn.disabled = false; btn.textContent = "Guardar y continuar";
    return;
  }
  // 2. Limpiar la marca must_change_password (edge function, con service_role).
  try { await supa.functions.invoke("admin-usuarios", { body: { accion: "confirmar_cambio_password" } }); }
  catch { /* si falla, la marca sigue y se le volverá a pedir; no bloquea el cambio ya hecho */ }
  // 3. Refrescar la sesión para que el JWT local recoja must_change_password=false.
  // Sin esto, arrancarDespuesDeLogin lee el JWT viejo —que todavía trae la marca
  // en true, porque el token no se actualiza solo al limpiarla en el servidor— y
  // vuelve a mostrar esta misma pantalla en bucle (el usuario "no entra" aunque
  // la contraseña ya se cambió).
  try { await supa.auth.refreshSession(); } catch { /* si no refresca, el reintento de login recogerá el JWT nuevo */ }
  await arrancarDespuesDeLogin(userId);
}

export async function continuarLoginConMFA(userId, bienvenida) {
  // El perfil (empresa y rol) hace falta sí o sí en cuanto se entre, y su
  // consulta no depende del chequeo de MFA. Se lanza YA para que viaje en
  // paralelo con la validación del dispositivo de confianza —que invoca una
  // edge function y puede sufrir arranque en frío— en vez de esperar a que
  // termine. Si el usuario acaba en la pantalla de MFA, la promesa simplemente
  // se descarta. El .catch evita un rechazo sin gestionar mientras tanto.
  const perfilPrometido = obtenerTenantIdDelUsuario(userId).catch(() => null);

  const { data: aal, error } = await supa.auth.mfa.getAuthenticatorAssuranceLevel();
  if (!error && aal && aal.nextLevel === "aal2" && aal.currentLevel !== "aal2") {
    // Dispositivo de confianza: si este navegador tiene un token firmado
    // vigente (emitido tras un reto MFA real, validez 15 días), se omite el
    // código. En dispositivos nuevos o con token vencido, reto normal.
    if (await dispositivoEsConfiable(userId)) {
      await arrancarDespuesDeLogin(userId, await perfilPrometido, bienvenida);
      return;
    }
    bienvenida?.cerrar();   // este dispositivo necesita el código: no se revela
    renderPantallaMFAChallenge(userId);
    return;
  }
  await arrancarDespuesDeLogin(userId, await perfilPrometido, bienvenida);
}
